import React, { useState, useCallback } from 'react';
import OrderDirectionsEnum from '../../Enums/OrderDirectionsEnum';
import UrlShortenerSearchParams from './UrlShortenerSearchParams';
import TabOfDataTable from '../../Elements/DataTable/TabOfDataTable';
import UrlShortenerService from '../../Services/UrlShortenerService';
import UrlShortenerItem from './UrlShortenerItem';
import ShownPanelsEnum from '../../Enums/ShownPanelsEnum';
import ButtonColorsEnum from '../../Enums/ButtonColorsEnum';
import ButtonRow from '../../Elements/ButtonRow';
import CrudTypesEnum from '../../Enums/CrudTypesEnum';
import GeneralEditWizzardBase from '../../Elements/GeneralEditWizzard/GeneralEditWizzardBaseFigma';
import EditUrlShortenerWindowDescription from './EditUrlShortenerWindowDescription';

const UrlShortenerAdmin = (props) => {
  const [orderBy] = useState('Id');
  const [orderDirection] = useState(OrderDirectionsEnum.Desc);
  const [searchItem, setSearchItem] = useState(new UrlShortenerSearchParams());
  const [shownPanel, setShownPanel] = useState(ShownPanelsEnum.None);
  const [selectedItem, setSelectedItem] = useState(null);

  const startSearch = useCallback((searchItem) => {
    setSearchItem(searchItem);
  }, []);

  const editFunction = useCallback((id, item, itemList) => {
    setShownPanel(ShownPanelsEnum.Edit);
    setSelectedItem(item);
  }, []);

  UrlShortenerItem.editFunction = editFunction;

  const handleButtonRowButtonClick = (panelId) => {
    panelId = panelId === shownPanel ? ShownPanelsEnum.None : panelId;
    setShownPanel(panelId);
  };

  const refresh = useCallback(() => {
    setSearchItem({ ...searchItem });
  }, [searchItem]);

  const renderOnePanel = (panelId, content) => {
    return shownPanel === panelId ? content : null;
  };

  const closeOverWindowWithRefresh = () => {
    closeOverWindowWithoutRefresh();
    refresh();
  };

  const closeOverWindowWithoutRefresh = () => {
    setShownPanel(ShownPanelsEnum.None);
  };

  const renderPanels = () => (
    <div>
      {renderOnePanel(
        ShownPanelsEnum.AddNewItem,
        <GeneralEditWizzardBase
          crudType={CrudTypesEnum.Create}
          editedItem={new UrlShortenerItem()}
          clickOnCancel={closeOverWindowWithoutRefresh}
          clickOnSave={closeOverWindowWithRefresh}
          windowDescription={EditUrlShortenerWindowDescription}
          errorCode={'LA141'}
        />
      )}
      {renderOnePanel(
        ShownPanelsEnum.Edit,
        <GeneralEditWizzardBase
          crudType={CrudTypesEnum.Update}
          editedItem={selectedItem}
          clickOnCancel={closeOverWindowWithoutRefresh}
          clickOnSave={closeOverWindowWithRefresh}
          windowDescription={EditUrlShortenerWindowDescription}
          errorCode={'LA152'}
        />
      )}
      {renderOnePanel(ShownPanelsEnum.EditItem, <div className='bg-white border rounded'>Edit Short URL</div>)}
    </div>
  );

  const renderButtonsAndPanels = () => (
    <>
      <ButtonRow
        colors={[ButtonColorsEnum.Primary]}
        tooltips={['Create']}
        keys={[ShownPanelsEnum.AddNewItem]}
        icons={['fa-solid fa-plus-circle']}
        roleKeys={['shorturl_newurl_button']}
        value={shownPanel}
        onClick={handleButtonRowButtonClick}
      />
      {renderPanels()}
    </>
  );

  return (
    <div className='contentwrapper'>
      {renderButtonsAndPanels()}
      <TabOfDataTable
        type={UrlShortenerItem}
        serviceFunction={UrlShortenerService.GetListBySearching}
        convertDBItemsFunction={UrlShortenerService.ConvertDBItems}
        orderDirection={orderDirection}
        orderBy={orderBy}
        searchItem={searchItem}
        showSearchStrip={true}
        searchParamsType={UrlShortenerSearchParams}
        clickOnStartSearch={startSearch}
        singleSearchLine={true}
        singleSearchLinePlaceholder='Search in id, type or result...'
        errorCode='USHA112'
      />
    </div>
  );
};

export default UrlShortenerAdmin;
